<template>
  <button
    class="google-btn"
    ref="googleButton"
  >
    <div class="google-icon-wrapper">
      <img
        class="google-icon"
        :src="$images.googleLogo"
      />
    </div>
    <div class="btn-text">{{ buttonLabel }}</div>
  </button>
</template>

<script>
import { mapState } from 'vuex';
import api from "@/api";
export default {
  props: {
    buttonLabel: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapState(['fairConfig'])
  },
  mounted () {
    this.initGoogleButton();
  },
  methods: {
    initGoogleButton() {
      // const SCOPES = 'https://www.googleapis.com/auth/calendar.events';
      this.gapi.load('auth2', async () => {
        const auth2 = await this.gapi.auth2.init({
          client_id: this.fairConfig.GA_SIGNIN_CLIENT_ID,
          cookiepolicy: 'single_host_origin',
        })
        auth2.attachClickHandler(this.$refs.googleButton, {},
          this.OnSuccess,
          this.OnGoogleAuthFail
        )
      })
    },
    OnSuccess(googleUser) {
      this.OnGoogleAuthSuccess(googleUser.getAuthResponse().id_token)
    },
    OnGoogleAuthFail(error) {
      console.log(error);
    },
    async OnGoogleAuthSuccess(idToken) {
      let obj = {
        sso_provider: "google",
        sso_token: idToken,
      };
      try {
        this.startLoading();
        let res = await api.sendSSOToken(obj);
        let sid = res.data.sid;
        let usr_id = res.data.usr_id;
        //handle sign up
        if (res.data.text) {
          this.$router.push('/validate?sso=google')
        }
        //handle login
        let setupStuff = () => {
          localStorage.setItem("sid", sid);
          localStorage.setItem("usr_id", usr_id);
        };
        if (sid && usr_id) {
          setupStuff();
          this.setLoggedIn(true);
          this.$router.push("/");
        }
      } catch (error) {
        if (error.response.data.status === "validate") {
          this.$router.push("/validate?q=true");
          return;
        }
        this.handleError(error);
      } finally {
        this.stopLoading();
      }
    }
  },
};
</script>

<style lang="scss" scoped>
* {
  box-sizing: border-box;
}
$white: #fff;
$google-blue: #4285f4;
$button-active-blue: #1669f2;

.google-btn {
  position: relative;
  display: flex;
  align-items: center;
  // width: 240px;
  height: 42px;
  background-color: $google-blue;
  border-radius: 2px;
  box-shadow: 0 3px 4px 0 rgba(0, 0, 0, 0.25);
  border: none;
  outline: none;
  padding: 1px;
  cursor: pointer;
  .google-icon-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 100%;
    border-radius: 2px;
    background-color: $white;
  }
  .google-icon {
    width: 50%;
    height: 50%;
  }
  .btn-text {
    text-align: center;
    color: $white;
    font-size: 14px;
    letter-spacing: 0.2px;
    font-family: "Roboto";
    width: calc(100% - 40px);
    font-weight: 800;
  }
  &:hover {
    box-shadow: 0 0 6px $google-blue;
  }
  &:active {
    background: $button-active-blue;
  }
}
</style>